export default __webpack_public_path__ + "static/media/final_background.d3ef1674.svg";